// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1__c9426d9410402af25294","cls2":"News-cls2__ab18ac3446835d8002e2 News-cls1__c9426d9410402af25294","variant-dense":"News-variant-dense___046b3c66106705dcfb4"};